import React from 'react';
import { Button } from './ui/button';
import { finalCTAData } from '../data/mockData';
import { ArrowRight } from 'lucide-react';

const FinalCTA = () => {
  const scrollToApplication = () => {
    const element = document.getElementById('application-form');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="py-20 bg-gradient-to-br from-slate-900 via-blue-900 to-slate-900 text-white">
      <div className="max-w-4xl mx-auto px-6 text-center">
        <h2 className="text-4xl md:text-5xl font-bold mb-6">
          {finalCTAData.sectionTitle}
        </h2>
        <p className="text-xl text-blue-100 mb-10 leading-relaxed">
          {finalCTAData.description}
        </p>
        <Button
          size="lg"
          onClick={scrollToApplication}
          className="bg-blue-600 hover:bg-blue-700 text-white px-8 py-6 text-lg font-semibold shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-105"
        >
          {finalCTAData.primaryCTA}
          <ArrowRight className="ml-2 h-5 w-5" />
        </Button>
      </div>
    </section>
  );
};

export default FinalCTA;
